import React, { useCallback, useEffect, useRef, useState } from 'react'

import { BannerType, BannerVariaion } from '@cox/core-ui8/dist/Banner'
import { LinkTypes, SimplifiedIcons } from '@cox/core-ui8/dist/Button'

import { OliverBackgroundColor, ReactOliverProps } from './types'
import { CHEVRON_RIGHT_WHITE, CIRCLE_EXCLAMATION_ERROR } from '../../assets/images'
import { isLocalHost } from '../../constants'
import { getImageSrc } from '../../utils/local-util'
import { getSpacing } from '../../utils/spacing-util'
import ReactBanner from '../ReactBanner'
import ReactButton from '../ReactButton'
import ReactText from '../ReactText'
import IsInEditorText from '../shared/IsInEditorText'
import './ReactOliver.scss'

const ReactOliver = (props: ReactOliverProps): React.JSX.Element => {
  const {
    iconPath,
    headline,
    inputText,
    disclaimer,
    buttonTypes,
    text,
    simplified = SimplifiedIcons.CHEVRON,
    icon = CHEVRON_RIGHT_WHITE,
    anchor,
    isInEditor,
    id = '',
    top = false,
    right = false,
    bottom = false,
    left = false,
    lob = '',
    backgroundColor = OliverBackgroundColor.grey
  } = props
  const oliverRef = useRef<HTMLDivElement>(null)
  const [chatHead, setChatHead] = useState(false)

  const [inputValue, setInputValue] = useState('')
  const [error, setError] = useState(false)

  const handleSubmit = useCallback(() => {
    if (!chatHead) {
      setError(true)
    }
  }, [chatHead])

  useEffect(() => {
    // chat widget only loads in envs
    if (!isLocalHost()) {
      const customInterval = setInterval(() => {
        const ctHead = document.querySelectorAll('body #web-messenger-container')
        const chatAvaliable = ctHead && ctHead.length > 0
        if (chatAvaliable) {
          setChatHead(true)
          setError(false)
          clearInterval(customInterval)
        }
      }, 650)
    }
  }, [])

  const handleChange = (event: any) => {
    setInputValue(event.target.value)
  }

  return (
    <>
      {IsInEditorText(isInEditor, ' React Oliver')}
      <div
        data-testid='react-oliver-container'
        className={`react-oliver-container oliver-${backgroundColor} oliver-padding ${getSpacing(
          top,
          right,
          bottom,
          left
        )} ${lob}`}
        ref={oliverRef}
        id={id}
      >
        {headline && <div className='subheading cox-text-title1-bold'>{headline}</div>}
        {error && (
          <ReactBanner
            bannerType={BannerType.DYNAMIC}
            variations={BannerVariaion.ERROR}
            // TODO: read errormessage and erroricon from props
            iconPath={CIRCLE_EXCLAMATION_ERROR}
            message={'Unable To Load Chat Window, Please Try Again Later'}
            openInNewTab={false}
          />
        )}
        <div className='oliver-disclaimer-container'>
          <div className='oliver'>
            <div className='oliver-frame'>
              <div className='oliver-icon'>
                <img src={`${getImageSrc(iconPath)}`} alt={'oliver icon'} />
              </div>
              <div className='oliver-input cox-text-paragraph2-medium'>
                <input placeholder={inputText} aria-label='oliver-input' value={inputValue} onChange={handleChange} />
              </div>
            </div>
            <div className='oliver-button'>
              <ReactButton
                buttonTypes={buttonTypes}
                id='oliver-button'
                linkType={LinkTypes.PAGE}
                linkUrl=''
                openInNewTab={false}
                text={text}
                simplified={simplified}
                activeIcon={icon}
                anchor={anchor}
                cssClass={' chat-trigger'}
                chatText={inputValue || inputText}
                customClickEvent={handleSubmit}
              />
            </div>
          </div>
          {disclaimer && (
            <div className='disclaimer cox-text-paragraph5-regular'>
              <ReactText text={disclaimer} />
            </div>
          )}
        </div>
      </div>
    </>
  )
}
export default ReactOliver
